// src/components/HelplineWidget.jsx
import React, { useState } from "react";
import "../styles/helpline.css";

export default function HelplineWidget() {
  const [open, setOpen] = useState(false);

  const phoneNumber = "+919650004929"; // change here if needed

  return (
    <div className="helpline-root">
      {/* FAB icon (shown when closed) */}
      {!open && (
        <button
          className="helpline-fab"
          onClick={() => setOpen(true)}
          aria-label="Open helpline"
        >
          <span className="helpline-fab-inner">
            <span className="helpline-fab-icon">📞</span>
            <span className="helpline-fab-label">Help</span>
          </span>
        </button>
      )}

      {/* Popup card (shown when open) */}
      {open && (
        <div className="helpline-card">
          <button
            className="helpline-close"
            onClick={() => setOpen(false)}
            aria-label="Close helpline"
          >
            ✕
          </button>

          <div className="helpline-header">
            <div className="helpline-header-icon-wrap">
              <span className="helpline-header-icon">📞</span>
            </div>
            <div>
              <h3 className="helpline-title">Talk to a Counsellor</h3>
              <p className="helpline-subtitle">
                Have doubts? We are happy to assist you!
              </p>
            </div>
          </div>

          <a href={`tel:${phoneNumber}`} className="helpline-call-btn">
            <span className="helpline-call-icon">📱</span>
            <span className="helpline-call-number">9650004929</span>
          </a>
        </div>
      )}
    </div>
  );
}
